var map = {
	"./backupDemo/white-logo.svg": 73706,
	"./brasilstartups/white-logo.svg": 15021,
	"./canaleducacao/white-logo.svg": 18553,
	"./egepi/white-logo.svg": 15565,
	"./fic/white-logo.svg": 79184,
	"./iesb/white-logo.svg": 39866,
	"./inkluziva/white-logo.svg": 50837,
	"./maiseducacao/white-logo.svg": 9998,
	"./oab/white-logo.svg": 61250,
	"./oros/white-logo.svg": 72603,
	"./powerforgirls/white-logo.svg": 61393,
	"./quartosecretariado/white-logo.svg": 15518,
	"./retina/white-logo.svg": 40365,
	"./seducpi/white-logo.svg": 78873,
	"./sett-solutions/white-logo.svg": 61032,
	"./siape/white-logo.svg": 68598,
	"./tjpara/white-logo.svg": 23170,
	"./unisescoop/white-logo.svg": 75710,
	"./vegalabs/white-logo.svg": 52375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43945;